/**
 * Main dashboard layout component.
 */

import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import PhoneVerificationBanner from './PhoneVerificationBanner';
import Footer from './Footer';

export default function Dashboard() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <PhoneVerificationBanner />
      <Container style={{ flex: 1 }}>
        <Outlet />
      </Container>
      <Footer />
    </div>
  );
}
